export default __webpack_public_path__ + "static/media/Spear of the Pagoda.8790c110.jpg";